var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWiFi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_4407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1250_4407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H7V23H23V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1250_4407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 21.0003C14.5336 21.0003 14.1391 20.8392 13.8169 20.5169C13.4947 20.1947 13.3336 19.8003 13.3336 19.3336C13.3336 18.8669 13.4947 18.4725 13.8169 18.1503C14.1391 17.8281 14.5336 17.6669 15.0002 17.6669C15.4669 17.6669 15.8613 17.8281 16.1836 18.1503C16.5058 18.4725 16.6669 18.8669 16.6669 19.3336C16.6669 19.8003 16.5058 20.1947 16.1836 20.5169C15.8613 20.8392 15.4669 21.0003 15.0002 21.0003ZM15.0002 13.667C15.8336 13.667 16.6253 13.8003 17.3756 14.067C18.1258 14.3337 18.8062 14.7003 19.4169 15.167C19.6391 15.3337 19.7531 15.5532 19.7589 15.8257C19.7647 16.0981 19.6673 16.3341 19.4669 16.5337C19.278 16.7225 19.0447 16.8199 18.7669 16.8257C18.4891 16.8314 18.2391 16.7563 18.0169 16.6003C17.5947 16.3114 17.128 16.0837 16.6169 15.917C16.1058 15.7503 15.5669 15.667 15.0002 15.667C14.4336 15.667 13.8947 15.7503 13.3836 15.917C12.8725 16.0837 12.4058 16.3114 11.9836 16.6003C11.7613 16.7559 11.5113 16.8281 11.2336 16.817C10.9558 16.8059 10.7224 16.7059 10.5336 16.517C10.3447 16.317 10.2502 16.081 10.2502 15.809C10.2502 15.537 10.3613 15.3174 10.5836 15.1503C11.1947 14.6837 11.8753 14.3197 12.6256 14.0583C13.3758 13.797 14.1673 13.6665 15.0002 13.667ZM15.0002 9.66699C16.3891 9.66699 17.6976 9.89477 18.9256 10.3503C20.1536 10.8059 21.2562 11.4503 22.2336 12.2837C22.4558 12.4725 22.5724 12.7059 22.5836 12.9837C22.5947 13.2614 22.5002 13.5003 22.3002 13.7003C22.1113 13.8892 21.878 13.9865 21.6002 13.9923C21.3224 13.9981 21.0724 13.9119 20.8502 13.7337C20.0502 13.0781 19.1531 12.5699 18.1589 12.209C17.1647 11.8481 16.1118 11.6674 15.0002 11.667C13.8887 11.6665 12.836 11.8472 11.8422 12.209C10.8484 12.5708 9.95112 13.079 9.15023 13.7337C8.928 13.9114 8.678 13.9977 8.40023 13.9923C8.12245 13.987 7.88911 13.8897 7.70023 13.7003C7.50023 13.5003 7.40578 13.2614 7.41689 12.9837C7.428 12.7059 7.54467 12.4725 7.76689 12.2837C8.74467 11.4503 9.84756 10.8059 11.0756 10.3503C12.3036 9.89477 13.6118 9.66699 15.0002 9.66699Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_4407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFi);
export default __webpack_public_path__ + "static/media/Wi-FI.de73949a1ef776670680d6926c477fc6.svg";
export { ForwardRef as ReactComponent };